var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 419.775,
    height: 60.594,
    viewBox: "0 0 419.775 60.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(-153.381 -5170.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M243.53,5206.671l-.7-.993a18.667,18.667,0,0,0,8.176-6.8,20.55,20.55,0,0,0,2.807-6.552,10.913,10.913,0,0,0,.213-3.936,15.966,15.966,0,0,0-1.142-3.759,19.2,19.2,0,0,0-8.547-9.738,26.377,26.377,0,0,0-9.263-3.044,36.551,36.551,0,0,0-5.272-.366H216.065V5230.7h7.6v-22.134H229.8a37.467,37.467,0,0,0,5.774-.443l.429.61,15.424,21.967h9.043Zm-13.209-4.6h-6.657l0-23.322h6.654a22.3,22.3,0,0,1,10.012,2,12.341,12.341,0,0,1,5.759,5.925,8.751,8.751,0,0,1,.848,4.173,9.184,9.184,0,0,1-.848,3.3,12.342,12.342,0,0,1-5.759,5.925A22.3,22.3,0,0,1,230.321,5202.074Z",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M312.155,5215.027c-4.226,6.123-10.592,9.359-18.41,9.359-13.052,0-22.524-9.794-22.524-23.288s9.472-23.289,22.524-23.289c7.553,0,13.818,3.111,17.642,8.759l.431.637,5.871-4.268-.4-.6c-5.034-7.55-13.176-11.541-23.548-11.541-17.32,0-30.381,13.025-30.381,30.3s13.061,30.3,30.381,30.3c10.36,0,19.023-4.338,24.393-12.215l.415-.608-5.974-4.16Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M365.351,5204.005H335.928V5171.48h-7.6v59.234h7.6V5211.1h29.423v19.617h7.6V5171.48h-7.6Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 7.687,
    height: 59.234,
    transform: "translate(387.513 5171.48)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M448.826,5211.2c0,1.151.089,2.627.186,3.893-.766-1.046-1.68-2.263-2.441-3.184l-34.7-41.026h-2.108v59.829h7.263v-39.723c0-1.128-.1-2.568-.216-3.818.753,1.028,1.64,2.208,2.38,3.1l34.484,40.768.222.264H456v-59.828h-7.177Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M508.878,5173.553l.114-.181v-1.892H470.309v6.922h27.082l-31.554,50.238-.114.181v1.893h43.439v-6.923H477.407Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M564.758,5230.7h8.4q-6.793-14.689-13.547-29.339-6.848-14.841-13.711-29.693c-.844,1.952-1.8,3.92-2.725,5.833-.614,1.267-1.227,2.531-1.807,3.787l-22.9,49.412h8.485l3.228-6.989h31.354Zm-31.011-14.722,12.1-26.2,12.106,26.2Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M199.76,5230.658l-18.942-40.994-12.607,27.483a21.274,21.274,0,0,0,6.016,3.638,19.106,19.106,0,0,0,6.261.846l-3.326-7.169,4.151-9.05,5.806,12.623,3.758,8.2a26.625,26.625,0,0,1-8.759,1.928l-.2.01c-.363.018-.727.037-1.1.037a28.575,28.575,0,0,1-13.833-3.65l-1.844-1.043-3.265,7.143h-8.5s26.639-57.183,27.486-59.138c4.589,9.924,22.769,49.328,27.306,59.138Z",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4fc620eb8a1bf14f9f3c88a89803516b.svg";
export { ForwardRef as ReactComponent };